var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pl",
      class: [
        "pl--" + _vm.layout,
        "pl--img-" + _vm.imageSide,
        "pl--thumb-" + _vm.imageSize,
        { "pl--loading": _vm.loading },
      ],
      style: _vm.gridVars,
    },
    [
      _vm.archiveTitle
        ? _c("h2", { staticClass: "pl__title" }, [
            _vm._v(_vm._s(_vm.archiveTitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.archiveDescription
        ? _c("p", { staticClass: "pl__desc" }, [
            _vm._v(_vm._s(_vm.archiveDescription)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.heading || _vm.moreLabel
        ? _c("div", { staticClass: "pl__head" }, [
            _vm.heading
              ? _c("h2", { staticClass: "pl__heading" }, [
                  _vm._v(_vm._s(_vm.heading)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "pl__rule" }),
            _vm._v(" "),
            _vm.moreLabel
              ? _c(
                  "a",
                  {
                    staticClass: "pl__more-link",
                    attrs: { href: _vm.moreUrl || "#" },
                  },
                  [
                    _vm._v(_vm._s(_vm.moreLabel) + " "),
                    _c("i", { staticClass: "fa fa-angle-right" }),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.items.length
        ? _c(
            "div",
            {
              staticClass: "pl__empty",
              attrs: { "data-testid": "cms-post-list-empty" },
            },
            [
              _c("i", { staticClass: "fa fa-newspaper-o" }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.emptyMessage))]),
            ]
          )
        : _vm.layout === "hero"
        ? [
            _c(
              "div",
              {
                staticClass: "pl__hero",
                class: { "pl__hero--solo": !_vm.hero.rest.length },
              },
              [
                _vm.hero.lead
                  ? _c(
                      "article",
                      {
                        staticClass: "pl__item pl__item--lead",
                        attrs: { "data-post-id": _vm.hero.lead.websitePostID },
                      },
                      [
                        _vm.showImage &&
                        _vm.hero.lead.websitePostFeatureImageUrl
                          ? _c(
                              "a",
                              {
                                staticClass: "pl__img pl__img--lead",
                                attrs: { href: _vm.hero.lead.websitePostUrl },
                              },
                              [
                                _c(
                                  "img",
                                  _vm._b(
                                    { staticClass: "pl__pic" },
                                    "img",
                                    _vm.pic(
                                      _vm.hero.lead,
                                      _vm.hero.rest.length ? "wide" : "lead"
                                    ),
                                    false
                                  )
                                ),
                                _vm.fmt(_vm.hero.lead)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "pl__play",
                                        class:
                                          "pl__play--" + _vm.fmt(_vm.hero.lead),
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa",
                                          class:
                                            _vm.fmt(_vm.hero.lead) === "audio"
                                              ? "fa-headphones"
                                              : "fa-play",
                                        }),
                                        _vm.duration(_vm.hero.lead)
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.duration(_vm.hero.lead)
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.creditFor(_vm.hero.lead)
                                  ? _c("small", { staticClass: "pl__credit" }, [
                                      _vm._v(
                                        _vm._s(_vm.creditFor(_vm.hero.lead))
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl__body" }, [
                          _vm.showCategory && _vm.cat(_vm.hero.lead)
                            ? _c(
                                "span",
                                { staticClass: "pl__cat", style: _vm.catStyle },
                                [_vm._v(_vm._s(_vm.cat(_vm.hero.lead)))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h3",
                            { staticClass: "pl__h", style: _vm.titleStyle },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.hero.lead.websitePostUrl },
                                },
                                [_vm._v(_vm._s(_vm.hero.lead.websitePostTitle))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showExcerpt && _vm.hero.lead.websitePostExcerpt
                            ? _c(
                                "p",
                                {
                                  staticClass: "pl__excerpt",
                                  style: _vm.excerptStyle,
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.hero.lead.websitePostExcerpt)
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl__meta", style: _vm.metaStyle },
                            [
                              _vm._t("badge", null, { item: _vm.hero.lead }),
                              _vm.by(_vm.hero.lead)
                                ? _c("span", { staticClass: "pl__by" }, [
                                    _vm._v("by "),
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.by(_vm.hero.lead))),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.by(_vm.hero.lead) && _vm.when(_vm.hero.lead)
                                ? _c("span", { staticClass: "pl__sep" }, [
                                    _vm._v("/"),
                                  ])
                                : _vm._e(),
                              _vm.when(_vm.hero.lead)
                                ? _c("span", { staticClass: "pl__date" }, [
                                    _vm._v(_vm._s(_vm.when(_vm.hero.lead))),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pl__side" },
                  _vm._l(_vm.hero.rest, function (it) {
                    return _c(
                      "article",
                      {
                        key: it.websitePostID,
                        staticClass: "pl__item pl__item--side",
                        attrs: { "data-post-id": it.websitePostID },
                      },
                      [
                        _vm.showImage && it.websitePostFeatureImageUrl
                          ? _c(
                              "a",
                              {
                                staticClass: "pl__img pl__img--thumb",
                                attrs: { href: it.websitePostUrl },
                              },
                              [
                                _c(
                                  "img",
                                  _vm._b(
                                    { staticClass: "pl__pic" },
                                    "img",
                                    _vm.pic(it, "thumb"),
                                    false
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl__body" }, [
                          _vm.showCategory && _vm.cat(it)
                            ? _c(
                                "span",
                                { staticClass: "pl__cat", style: _vm.catStyle },
                                [_vm._v(_vm._s(_vm.cat(it)))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass: "pl__h pl__h--sm",
                              style: _vm.titleStyle,
                            },
                            [
                              _c("a", { attrs: { href: it.websitePostUrl } }, [
                                _vm._v(_vm._s(it.websitePostTitle)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl__meta", style: _vm.metaStyle },
                            [
                              _vm._t("badge", null, { item: it }),
                              _vm.by(it)
                                ? _c("span", { staticClass: "pl__by" }, [
                                    _vm._v("by "),
                                    _c("b", [_vm._v(_vm._s(_vm.by(it)))]),
                                  ])
                                : _vm._e(),
                              _vm.by(it) && _vm.when(it)
                                ? _c("span", { staticClass: "pl__sep" }, [
                                    _vm._v("/"),
                                  ])
                                : _vm._e(),
                              _vm.when(it)
                                ? _c("span", { staticClass: "pl__date" }, [
                                    _vm._v(_vm._s(_vm.when(it))),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        : _vm.layout === "playlist"
        ? [
            _c("div", { staticClass: "pl__playlist" }, [
              _c("div", { staticClass: "pl__player" }, [
                _vm.activeEmbed && !_vm.activeIsAudio
                  ? _c("iframe", {
                      staticClass: "pl__player-frame",
                      attrs: {
                        src: _vm.activeEmbed,
                        allow:
                          "accelerometer; autoplay; encrypted-media; picture-in-picture",
                        allowfullscreen: "",
                        loading: "lazy",
                        title: _vm.active.websitePostTitle,
                      },
                    })
                  : _vm.activeEmbed && _vm.activeIsAudio
                  ? _c("audio", {
                      staticClass: "pl__player-audio",
                      attrs: {
                        src: _vm.activeEmbed,
                        controls: "",
                        preload: "none",
                      },
                    })
                  : _vm.active
                  ? _c(
                      "a",
                      {
                        staticClass: "pl__img pl__img--lead",
                        attrs: { href: _vm.active.websitePostUrl },
                      },
                      [
                        _c(
                          "img",
                          _vm._b(
                            { staticClass: "pl__pic" },
                            "img",
                            _vm.pic(_vm.active, "wide"),
                            false
                          )
                        ),
                        _vm._m(0),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.active
                  ? _c("div", { staticClass: "pl__body pl__player-body" }, [
                      _vm.showCategory && _vm.cat(_vm.active)
                        ? _c(
                            "span",
                            { staticClass: "pl__cat", style: _vm.catStyle },
                            [_vm._v(_vm._s(_vm.cat(_vm.active)))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "h3",
                        { staticClass: "pl__h", style: _vm.titleStyle },
                        [
                          _c(
                            "a",
                            { attrs: { href: _vm.active.websitePostUrl } },
                            [_vm._v(_vm._s(_vm.active.websitePostTitle))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showExcerpt && _vm.active.websitePostExcerpt
                        ? _c(
                            "p",
                            {
                              staticClass: "pl__excerpt",
                              style: _vm.excerptStyle,
                            },
                            [_vm._v(_vm._s(_vm.active.websitePostExcerpt))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "ol",
                { staticClass: "pl__episodes pl__episodes--side" },
                _vm._l(_vm.items, function (it, i) {
                  return _c(
                    "li",
                    {
                      key: it.websitePostID,
                      staticClass: "pl__episode",
                      class: { "pl__episode--active": i === _vm.activeIndex },
                      attrs: { "data-post-id": it.websitePostID },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "pl__episode-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.activeIndex = i
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "pl__episode-thumb" }, [
                            it.websitePostFeatureImageUrl
                              ? _c(
                                  "img",
                                  _vm._b(
                                    { staticClass: "pl__pic" },
                                    "img",
                                    _vm.pic(it, "thumb"),
                                    false
                                  )
                                )
                              : _vm._e(),
                            _c("i", {
                              staticClass: "fa",
                              class:
                                i === _vm.activeIndex
                                  ? "fa-volume-up"
                                  : "fa-play",
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "pl__body" }, [
                            _c(
                              "span",
                              {
                                staticClass: "pl__h pl__h--sm",
                                style: _vm.titleStyle,
                              },
                              [_vm._v(_vm._s(it.websitePostTitle))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pl__meta", style: _vm.metaStyle },
                              [
                                _vm.duration(it)
                                  ? _c(
                                      "span",
                                      { staticClass: "pl__duration" },
                                      [_vm._v(_vm._s(_vm.duration(it)))]
                                    )
                                  : _vm._e(),
                                _vm.duration(it) && _vm.when(it)
                                  ? _c("span", { staticClass: "pl__sep" }, [
                                      _vm._v("/"),
                                    ])
                                  : _vm._e(),
                                _vm.when(it)
                                  ? _c("span", { staticClass: "pl__date" }, [
                                      _vm._v(_vm._s(_vm.when(it))),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm.layout === "episodes"
        ? [
            _c(
              "ol",
              { staticClass: "pl__episodes" },
              _vm._l(_vm.items, function (it, i) {
                return _c(
                  "li",
                  {
                    key: it.websitePostID,
                    staticClass: "pl__episode",
                    class: { "pl__episode--active": i === _vm.activeIndex },
                    attrs: { "data-post-id": it.websitePostID },
                  },
                  [
                    _c("div", { staticClass: "pl__episode-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "pl__episode-play",
                          attrs: {
                            type: "button",
                            "aria-label":
                              (i === _vm.activeIndex ? "Hide " : "Play ") +
                              it.websitePostTitle,
                          },
                          on: {
                            click: function ($event) {
                              _vm.activeIndex = i === _vm.activeIndex ? -1 : i
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa",
                            class:
                              i === _vm.activeIndex ? "fa-stop" : "fa-play",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showImage && it.websitePostFeatureImageUrl
                        ? _c(
                            "a",
                            {
                              staticClass: "pl__img pl__img--thumb",
                              attrs: { href: it.websitePostUrl },
                            },
                            [
                              _c(
                                "img",
                                _vm._b(
                                  { staticClass: "pl__pic" },
                                  "img",
                                  _vm.pic(it, "thumb"),
                                  false
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "pl__body" }, [
                        _vm.showCategory && _vm.cat(it)
                          ? _c(
                              "span",
                              { staticClass: "pl__cat", style: _vm.catStyle },
                              [_vm._v(_vm._s(_vm.cat(it)))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass: "pl__h pl__h--sm",
                            style: _vm.titleStyle,
                          },
                          [
                            _c("a", { attrs: { href: it.websitePostUrl } }, [
                              _vm._v(_vm._s(it.websitePostTitle)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showExcerpt && it.websitePostExcerpt
                          ? _c(
                              "p",
                              {
                                staticClass: "pl__excerpt pl__excerpt--one",
                                style: _vm.excerptStyle,
                              },
                              [_vm._v(_vm._s(it.websitePostExcerpt))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pl__meta", style: _vm.metaStyle },
                          [
                            _vm.duration(it)
                              ? _c("span", { staticClass: "pl__duration" }, [
                                  _vm._v(_vm._s(_vm.duration(it))),
                                ])
                              : _vm._e(),
                            _vm.duration(it) && _vm.when(it)
                              ? _c("span", { staticClass: "pl__sep" }, [
                                  _vm._v("/"),
                                ])
                              : _vm._e(),
                            _vm.when(it)
                              ? _c("span", { staticClass: "pl__date" }, [
                                  _vm._v(_vm._s(_vm.when(it))),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    i === _vm.activeIndex && _vm.embedFor(it)
                      ? _c("div", { staticClass: "pl__episode-player" }, [
                          _vm.isAudio(it)
                            ? _c("audio", {
                                staticClass: "pl__player-audio",
                                attrs: {
                                  src: _vm.embedFor(it),
                                  controls: "",
                                  autoplay: "",
                                  preload: "none",
                                },
                              })
                            : _c("iframe", {
                                staticClass: "pl__player-frame",
                                attrs: {
                                  src: _vm.embedFor(it),
                                  allow:
                                    "accelerometer; autoplay; encrypted-media; picture-in-picture",
                                  allowfullscreen: "",
                                  title: it.websitePostTitle,
                                },
                              }),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : _c(
            "div",
            { staticClass: "pl__items" },
            _vm._l(_vm.items, function (it, i) {
              return _c(
                "article",
                {
                  key: it.websitePostID,
                  staticClass: "pl__item",
                  attrs: { "data-post-id": it.websitePostID },
                },
                [
                  _vm.showImage && it.websitePostFeatureImageUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "pl__img",
                          attrs: { href: it.websitePostUrl },
                        },
                        [
                          _c(
                            "img",
                            _vm._b(
                              { staticClass: "pl__pic" },
                              "img",
                              _vm.pic(
                                it,
                                _vm.layout === "cover" && i === 0 ? "lead" : ""
                              ),
                              false
                            )
                          ),
                          _vm.fmt(it)
                            ? _c(
                                "span",
                                {
                                  staticClass: "pl__play",
                                  class: "pl__play--" + _vm.fmt(it),
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa",
                                    class:
                                      _vm.fmt(it) === "audio"
                                        ? "fa-headphones"
                                        : "fa-play",
                                  }),
                                  _vm.duration(it)
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.duration(it))),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "pl__body" }, [
                    _vm.showCategory && _vm.cat(it)
                      ? _c(
                          "span",
                          { staticClass: "pl__cat", style: _vm.catStyle },
                          [_vm._v(_vm._s(_vm.cat(it)))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h3", { staticClass: "pl__h", style: _vm.titleStyle }, [
                      _c("a", { attrs: { href: it.websitePostUrl } }, [
                        _vm._v(_vm._s(it.websitePostTitle)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.showExcerpt && it.websitePostExcerpt
                      ? _c(
                          "p",
                          {
                            staticClass: "pl__excerpt",
                            style: _vm.excerptStyle,
                          },
                          [_vm._v(_vm._s(it.websitePostExcerpt))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pl__meta", style: _vm.metaStyle },
                      [
                        _vm._t("badge", null, { item: it }),
                        _vm.by(it)
                          ? _c("span", { staticClass: "pl__by" }, [
                              _vm._v("by "),
                              _c("b", [_vm._v(_vm._s(_vm.by(it)))]),
                            ])
                          : _vm._e(),
                        _vm.by(it) && _vm.when(it)
                          ? _c("span", { staticClass: "pl__sep" }, [
                              _vm._v("/"),
                            ])
                          : _vm._e(),
                        _vm.when(it)
                          ? _c("span", { staticClass: "pl__date" }, [
                              _vm._v(_vm._s(_vm.when(it))),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.pagination === "loadMore" && _vm.hasMore
        ? _c("div", { staticClass: "pl__more" }, [
            _c(
              "button",
              {
                staticClass: "pl__more-btn",
                attrs: { type: "button", disabled: _vm.loadingMore },
                on: { click: _vm.loadMore },
              },
              [
                _vm.loadingMore
                  ? _c("i", { staticClass: "fa fa-circle-o-notch fa-spin" })
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.loadingMore
                        ? _vm.t("common.loading")
                        : _vm.t("common.loadMore")
                    ) +
                    "\n\t\t"
                ),
              ]
            ),
          ])
        : _vm.pagination === "pages" && _vm.pagesTotal > 1
        ? _c(
            "nav",
            { staticClass: "pl__pages", attrs: { "aria-label": "Pages" } },
            [
              _vm.pageNumber > 1
                ? _c(
                    "a",
                    {
                      staticClass: "pl__page",
                      attrs: { href: _vm.pageUrl(_vm.pageNumber - 1) },
                    },
                    [_vm._v("« Newer")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "pl__page pl__page--info" }, [
                _vm._v(
                  "Page " +
                    _vm._s(_vm.pageNumber) +
                    " of " +
                    _vm._s(_vm.pagesTotal)
                ),
              ]),
              _vm._v(" "),
              _vm.pageNumber < _vm.pagesTotal
                ? _c(
                    "a",
                    {
                      staticClass: "pl__page",
                      attrs: { href: _vm.pageUrl(_vm.pageNumber + 1) },
                    },
                    [_vm._v("Older »")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "pl__play" }, [
      _c("i", { staticClass: "fa fa-play" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }